export default "__VITE_ASSET__BhDdT4mQ__";